import { render, staticRenderFns } from "./Headquarter.vue?vue&type=template&id=50c50b96&scoped=true&"
import script from "./Headquarter.vue?vue&type=script&lang=js&"
export * from "./Headquarter.vue?vue&type=script&lang=js&"
import style0 from "./Headquarter.vue?vue&type=style&index=0&id=50c50b96&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50c50b96",
  null
  
)

component.options.__file = "Headquarter.vue"
export default component.exports